import { ArrowRight, Lightbulb, Building2, TrendingUp } from "lucide-react"
import { SectionReveal, StaggerReveal, StaggerItem } from "~/components/company/SectionReveal"

const personas = [
  {
    icon: Lightbulb,
    title: "Non-Technical Founders",
    description: "You have the vision and domain expertise. You need a team that can turn your idea into a real product, fast.",
    painPoints: [
      "Tired of failed freelancer projects",
      "Can't afford 4-8 weeks to hire developers",
      "Need a technical partner, not just coders"
    ],
    solution: "MVP Development",
    href: "/services/mvp-development"
  },
  {
    icon: Building2,
    title: "Operations Leaders",
    description: "Your team is drowning in repetitive work. You know there's a better way, but you don't have the technical resources to build it.",
    painPoints: [
      "Manual processes eating up hours daily",
      "Data scattered across 10+ tools",
      "Team doing work that should be automated"
    ],
    solution: "AI Workflow Automation",
    href: "/services/ai-workflow-automation"
  },
  {
    icon: TrendingUp,
    title: "Startup CTOs & Engineering Leads",
    description: "Your backlog is growing faster than your team. You need experienced developers who can ship without handholding.",
    painPoints: [
      "Can't hire fast enough",
      "Junior devs need too much management",
      "Missing deadlines on important features"
    ],
    solution: "Engineering Team Extension",
    href: "/services/dedicated-developers"
  }
]

export function WhoWeHelpSection() {
  return (
    <section className="w-full bg-white py-16 md:py-20 lg:py-24">
      <div className="container px-4 md:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto space-y-12">
          <SectionReveal className="space-y-4 text-center">
            <p className="text-[#ed2132] font-semibold">WHO WE HELP</p>
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900">
              Built for People Who Need to Move Fast
            </h2>
          </SectionReveal>

          <StaggerReveal className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {personas.map((persona) => {
              const Icon = persona.icon
              return (
                <StaggerItem key={persona.title}>
                  <div className="space-y-6 group">
                    <div className="space-y-4">
                      <div className="flex items-center justify-center h-12 w-12 rounded-lg bg-red-100 transition-transform duration-300 group-hover:scale-110">
                        <Icon className="w-6 h-6 text-[#ed2132]" />
                      </div>
                      <h3 className="text-xl font-bold text-slate-900">{persona.title}</h3>
                      <p className="text-slate-600 text-sm leading-relaxed">{persona.description}</p>
                    </div>

                    <div className="space-y-2">
                      <p className="text-xs font-semibold text-slate-500 uppercase tracking-wide">Common pain points:</p>
                      <ul className="space-y-1">
                        {persona.painPoints.map((point, idx) => (
                          <li key={idx} className="flex items-start gap-2 text-sm text-slate-600">
                            <span className="text-slate-400">•</span>
                            {point}
                          </li>
                        ))}
                      </ul>
                    </div>

                    <a
                      href={persona.href}
                      className="inline-flex items-center gap-2 text-sm font-semibold text-[#ed2132] hover:gap-3 transition-all"
                    >
                      Explore {persona.solution}
                      <ArrowRight className="h-4 w-4" />
                    </a>
                  </div>
                </StaggerItem>
              )
            })}
          </StaggerReveal>
        </div>
      </div>
    </section>
  )
}
